var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingConfig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0029 11.7317C40.0029 10.7652 40.7864 9.98173 41.7529 9.98173H48.7529C49.7194 9.98173 50.5029 10.7652 50.5029 11.7317C50.5029 12.6982 49.7194 13.4817 48.7529 13.4817H41.7529C40.7864 13.4817 40.0029 12.6982 40.0029 11.7317Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4196 5.31506C33.3861 5.31506 34.1696 6.09857 34.1696 7.06506V16.3984C34.1696 17.3649 33.3861 18.1484 32.4196 18.1484C31.4531 18.1484 30.6696 17.3649 30.6696 16.3984V7.06506C30.6696 6.09857 31.4531 5.31506 32.4196 5.31506Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00293 11.7317C5.00293 10.7652 5.78643 9.98173 6.75293 9.98173H32.4196C33.3861 9.98173 34.1696 10.7652 34.1696 11.7317C34.1696 12.6982 33.3861 13.4817 32.4196 13.4817H6.75293C5.78643 13.4817 5.00293 12.6982 5.00293 11.7317Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00293 28.0651C5.00293 27.0986 5.78643 26.3151 6.75293 26.3151H16.0863C17.0528 26.3151 17.8363 27.0986 17.8363 28.0651C17.8363 29.0316 17.0528 29.8151 16.0863 29.8151H6.75293C5.78643 29.8151 5.00293 29.0316 5.00293 28.0651Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4196 21.6484C26.3861 21.6484 27.1696 22.4319 27.1696 23.3984V32.7317C27.1696 33.6982 26.3861 34.4817 25.4196 34.4817C24.4531 34.4817 23.6696 33.6982 23.6696 32.7317V23.3984C23.6696 22.4319 24.4531 21.6484 25.4196 21.6484Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6696 28.0651C23.6696 27.0986 24.4531 26.3151 25.4196 26.3151H51.0863C52.0528 26.3151 52.8363 27.0986 52.8363 28.0651C52.8363 29.0316 52.0528 29.8151 51.0863 29.8151H25.4196C24.4531 29.8151 23.6696 29.0316 23.6696 28.0651Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0029 44.3984C40.0029 43.4319 40.7864 42.6484 41.7529 42.6484H48.7529C49.7194 42.6484 50.5029 43.4319 50.5029 44.3984C50.5029 45.3649 49.7194 46.1484 48.7529 46.1484H41.7529C40.7864 46.1484 40.0029 45.3649 40.0029 44.3984Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4196 37.9817C33.3861 37.9817 34.1696 38.7652 34.1696 39.7317V49.0651C34.1696 50.0316 33.3861 50.8151 32.4196 50.8151C31.4531 50.8151 30.6696 50.0316 30.6696 49.0651V39.7317C30.6696 38.7652 31.4531 37.9817 32.4196 37.9817Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00293 44.3984C5.00293 43.4319 5.78643 42.6484 6.75293 42.6484H32.4196C33.3861 42.6484 34.1696 43.4319 34.1696 44.3984C34.1696 45.3649 33.3861 46.1484 32.4196 46.1484H6.75293C5.78643 46.1484 5.00293 45.3649 5.00293 44.3984Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingConfig);
export default __webpack_public_path__ + "static/media/setting-config.a674fb8e.svg";
export { ForwardRef as ReactComponent };